import "../chunk-3W5G4CYI.js";
const versionSelector = (clerkJSVersion) => {
  if (clerkJSVersion) {
    return clerkJSVersion;
  }
  const prereleaseTag = getPrereleaseTag("4.30.10");
  if (prereleaseTag) {
    if (prereleaseTag === "snapshot") {
      return "4.71.3";
    }
    return prereleaseTag;
  }
  return getMajorVersion("4.30.10");
};
const getPrereleaseTag = (packageVersion) => {
  var _a;
  return (_a = packageVersion.match(/-(.*)\./)) == null ? void 0 : _a[1];
};
const getMajorVersion = (packageVersion) => packageVersion.split(".")[0];
export {
  versionSelector
};
//# sourceMappingURL=versionSelector.js.map